export const getBlogList = state => state.blog.blogList;
export const getBlogDetails = state => state.blog.blogDetails;
